import MetricCard from "./dashboard/MetricCard";
import GoogleRating from "./dashboard/GoogleRating";
import OrdersList from "./dashboard/OrdersList";
import ReviewsList from "./dashboard/ReviewsList";

export default function Dashboard({ data }) {
	return (
		<section className="dashboard-panel">
			<div className="panel-head">
				<div>
					<p className="panel-overline">Aperçu général</p>
					<h2>Tableau de bord</h2>
					<p className="panel-sub">Suivi instantané des indicateurs clés de la boutique.</p>
				</div>
				<div className="panel-hint">Données affichées à titre indicatif.</div>
			</div>

			<div className="stat-grid">
				{data.metrics.map((metric) => (
					<MetricCard key={metric.id} metric={metric} />
				))}
			</div>

			<div className="dashboard-cols">
				<GoogleRating google={data.google} />
				<OrdersList orders={data.orders} />
			</div>

			<ReviewsList reviews={data.reviews} />
		</section>
	);
}
